import { render, staticRenderFns } from "./OrgHomeMarketingSources.vue?vue&type=template&id=dea2bfde&scoped=true&"
import script from "./OrgHomeMarketingSources.vue?vue&type=script&lang=js&"
export * from "./OrgHomeMarketingSources.vue?vue&type=script&lang=js&"
import style0 from "./OrgHomeMarketingSources.vue?vue&type=style&index=0&id=dea2bfde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea2bfde",
  null
  
)

export default component.exports